import { Badge, Box, Flex, Heading } from '@radix-ui/themes';
import { ErrorBoundary } from 'components/common/error-boundary';
import { UserSectionReassignLists } from 'components/common/settings-dialog/main-sections/user-section/reassign-lists';
import { UserSectionTeamAdmins } from 'components/common/settings-dialog/main-sections/user-section/team-admins';
import { CommonTabs } from 'components/common/tabs';
import { UserSettingsTabKey } from 'enums/settings';
import { t } from 'i18next';
import { RADIX } from 'lib_ts/enums/radix-ui';
import { useState } from 'react';
import { useAuthStore } from 'stores/use-auth-store';

interface IProps {
  initialTab?: UserSettingsTabKey;
  onClose: () => void;
}

export const UserSection = (props: IProps) => {
  const current = useAuthStore((s) => s.current);

  const [tab, setTab] = useState(
    props.initialTab ?? UserSettingsTabKey.ReassignPitchLists
  );

  return (
    <ErrorBoundary identifier="UserSection">
      <Flex
        className={RADIX.VFLEX.GROW}
        direction="column"
        gap={RADIX.FLEX.GAP.MD}
        justify="between"
      >
        <Box>
          <Flex gap={RADIX.FLEX.GAP.SM}>
            <Heading size={RADIX.HEADING.SIZE.MD}>{t('settings.user')}</Heading>
            <Badge>{current.email}</Badge>
          </Flex>

          <CommonTabs
            value={tab}
            onValueChange={(value) => setTab(value as UserSettingsTabKey)}
            tabs={[
              {
                value: UserSettingsTabKey.ReassignPitchLists,
                label: 'settings.reassign-pitch-lists',
                content: <UserSectionReassignLists onClose={props.onClose} />,
              },
              {
                value: UserSettingsTabKey.TeamAdmins,
                label: 'settings.team-admins',
                content: <UserSectionTeamAdmins />,
              },
            ]}
          />
        </Box>
      </Flex>
    </ErrorBoundary>
  );
};
